export default __webpack_public_path__ + "static/917-a349f62bd036ce9e5aaf0a7519f5b96b.gif";